import { useSignedInContext } from "../auth/useSignedInContext";

export function HomePage() {
  const { member } = useSignedInContext();
  return (
    <section className="pw-card">
      <p style={{ margin: "0 0 0.15rem", fontSize: "11px", fontWeight: 700, letterSpacing: "0.8px", textTransform: "uppercase", color: "var(--pw-color-text-muted)" }}>
        Parawissen
      </p>
      <h1 style={{ margin: "0 0 0.4rem", fontSize: "1.6rem", fontWeight: 600, letterSpacing: "-0.02em" }}>
        Willkommen, {member.displayName}.
      </h1>
      <p style={{ margin: 0, fontSize: "0.88rem", color: "var(--pw-color-text-muted)", maxWidth: "52ch" }}>
        Bibliothek, Wissenschat und privater Podcast folgen in den nächsten Ausbaustufen. Aktuell aktiv:
        Mitgliederbereich, Einladungen und Kontoverwaltung.
      </p>
    </section>
  );
}
